export default __webpack_public_path__ + "10707c279cd408093b0054e4b5b7615e.glb";